import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {PropertiesService} from '../../../../core/http/properties/properties.service';
import {PropertyDetailsModel} from '../../../../shared/models/properties/properties.models';
import {UserService} from '../../../../core/services/user/user.service';
import {
  StripeAfterPaymentResponse,
  StripePaymentResponseIntent
} from '../../../../core/services/checkout/models/stripe';
import {ToastrService} from 'ngx-toastr';
import {MosService} from '../../services/mos.service';
import {PermissionService} from '../../../../core/services/permission/permission.service';
import {UserPermissionEnum} from '../../../../shared/enums/permission.enum';
import {Moment} from 'moment/moment';
import {YMD_FORMAT} from '../../../../core/constants/date-and-time-formats.constants';
import moment from 'moment';

const oldPrice: number = 84;
const newPrice: number = 99;

@Component({
  selector: 'app-ccpayment',
  templateUrl: './ccpayment.component.html',
  styleUrls: ['./ccpayment.component.scss']
})
export class CCPaymentComponent implements OnInit {

  private propertyDetails: PropertyDetailsModel;

  priceChangeDate: string = '2025-04-22';
  ccAmount: number;

  private userId: number;
  propertyId: number;
  private relatedId: number;
  private questionnaireType: string;

  get description(): string {
    const userData = this.userService.getDetailsFromStorage();
    return 'Buyer administration fee for ' + userData?.name;
  }

  get canDoPayment(): boolean {
    return this.permissionService.hasPermission(UserPermissionEnum.BUYER_PAYMENT_CREATE_OWN);
  }

  get propertyAddress(): string | null {
    const houseNameNumber = this.propertyDetails?.houseNameNumber ? this.propertyDetails.houseNameNumber : '';
    const address1 = this.propertyDetails?.address1 ? this.propertyDetails.address1 : '';
    const address2 = this.propertyDetails?.address2 ? this.propertyDetails.address2 : '';
    const town = this.propertyDetails?.town ? this.propertyDetails.town : '';
    const postcode = this.propertyDetails?.postcode ? this.propertyDetails.postcode : '';

    return this.propertyDetails ?
      `${houseNameNumber} ${address1} ${address2} ${town} ${postcode}`
      : null;
  }

  constructor(private activatedRoute: ActivatedRoute,
              private propertyService: PropertiesService,
              private toastService: ToastrService,
              private router: Router,
              private mosService: MosService,
              private permissionService: PermissionService,
              private userService: UserService) {
  }

  ngOnInit(): void {
    this.activatedRoute.params.subscribe((params) => {
      this.loadPropertyData(params.propertyId);
      this.userId = params.userId;
      this.propertyId = params.propertyId;
      this.relatedId = params.relatedId;
      this.questionnaireType = params.questionnaireType;
    });
  }

  onPaymentDone(event: StripePaymentResponseIntent): void {
    this.userService.createBuyerPayment(this.userId, this.propertyId, event.id, 'completed').subscribe((data) => {
      this.toastService.success('Payment acknowledged. Please proceed to finalise your Memorandum of Sale.');
      this.mosService.ccPaymentDone = true;
      this.router.navigate(['offers/properties', this.propertyId, 'memorandum', this.relatedId, this.questionnaireType, this.userId], {queryParams: {afterPayment: true}});
    });
  }

  private loadPropertyData(propertyId: number): void {
    const params = {
      fields: [
        'buyer-viewing-appointment-date',
      ],
    };
    this.propertyService.getPropertyDetails(propertyId, params, true).subscribe((data) => {
      this.propertyDetails = data.data;
      this.calculateCcAmount();
    });
  }

  private calculateCcAmount(): void {
    const referenceDate: Moment = moment(this.priceChangeDate, YMD_FORMAT);
    const rawViewingDate: string = this.propertyDetails?.buyerViewingAppointmentDate;

    const buyerViewingDate: Moment = rawViewingDate
      ? moment(rawViewingDate, YMD_FORMAT)
      : moment();

    this.ccAmount = buyerViewingDate.isBefore(referenceDate) ? oldPrice : newPrice;
  }
}
